/* eslint-disable import/prefer-default-export */

import { EMAIL_REGEX } from "types/common"
import { LocationItem } from "types/location"

export function toTitleCase(text: string) {
    const words = text.split(' ').map((word: string) => {
        return `${word.substr(0, 1).toUpperCase()}${word
            .substr(1)
            .toLowerCase()}`
    })

    return words.join(' ')
}

export function betterPathname(pathname: string) {
    const words: string[] = []
    pathname.split('/').forEach((word: string) => {
        if (word.length > 0) words.push(word)
    })

    return words
}

export function checkPasswordStrength(password: string) {
    const check = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
    return check.test(password)
}

export function validateEmail(email: string) {
    const regexp = new RegExp(EMAIL_REGEX)
    return regexp.test(email)
}

export function toFullLocationAddress(location: LocationItem) { //TODO: benchmark and optimize
    return (
        `${location.city}${location.city && location.state ? ', ' : ' '}${location.state}${location.city || location.state ? ', ' : ' '}${location.country}${location.country && location.zip ? ', ' : ' '}${location.zip}`
    )
}

// to format phone number
export function formatPhoneNumber(input: string): string {
    // Remove non-digit characters
    const cleaned = input.replace(/\D/g, '');
  
    // Format the phone number as XXX-XXX-XXXX (any extra digits after the second hyphen)
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{0,4})/);
  
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    
    return input;
  }

  
export function formatDate(date: Date): string {
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }
  
